module.exports = __webpack_public_path__ + "static/media/train-card9.721487db.jpg";